import React, {Component} from 'react';
import {YesNoModal} from "../../elements/YesNoModal";
import {EditClientAdAccountModalButton} from "./EditClientAdAccountModalButton";
import {EditEventsModal} from "./EditEventsModal";
import {FaIcon} from "../../FaIcon";
import {CHANNEL_INFO_BY_CHANNEL, CHANNEL_TYPE_PAID_MEDIA} from "../../channels/channels";
import {ReconnectAdAccountModal} from "../../agency/connections/ReconnectAdAccountModal";
import {getTranslatedName, stripActionPrefix} from "../../selects/actionCategories";
import AdAccountBudgetWithDetails from "../../agency/AdAccountBudgetWithDetails";
import {ChannelLogo} from "../../channels/ChannelLogo";
import {DAILY_LIMIT_TYPE_DATA, getLocalizedShortText, DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_ONLY_BUDGET, DAILY_LIMIT_TYPE_DAILY_AD_ACCOUNT_COST_AND_BUDGET} from "../../../daily_limits";
import {Alert} from "reactstrap";
import { withTranslation } from 'react-i18next';
import {
    VIEW_MODE_AGENCY_ACCOUNTS,
    VIEW_MODE_CLIENT_ACCOUNTS,
    VIEW_MODE_CLIENT_MONITORING
} from "./ClientAdAccountAndStoresList";
import {LookerCCStatus} from "../../agency/looker_cc/LookerCCStatus";
import {DataNodeStatus} from "../../agency/data_node/DataNodeStatus";
import {MCPStatus} from "../../agency/mcp/MCPStatus";
import {HELP_LOOKER_CC, HELP_DATA_EXPLORER, HELP_MCP_INTERNAL, LinkToArticle} from "../../help_center/LinkToArticle";

class ClientAdAccountRowClass extends Component {
    constructor(props) {
        super(props);
        this.handleClientAdAccountRemove = this.handleClientAdAccountRemove.bind(this);
        this.handleClientAdAccountEdited = this.handleClientAdAccountEdited.bind(this);

        this.handleReconnectToggle = this.handleReconnectToggle.bind(this);

        this.state = {
            isSaving: this.props.isSaving,
            showEditEventsModal: false,
            showReconnectModal: false,
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.isSaving !== this.props.isSaving) {
            this.setState({isSaving: this.props.isSaving});
        }
    }

    handleClientAdAccountRemove() {
        this.props.onRemove(this.props.clientAdAccount.id)
    }

    handleClientAdAccountEdited() {
        if (typeof this.props.onEdit === 'function') {
            this.props.onEdit(this.props.clientAdAccount.id);
        }
    }

    handleReconnectToggle() {
        this.setState({ showReconnectModal: !this.state.showReconnectModal });
    }

    getInternalProblemTextDetail() {
        const { t } = this.props;
        if (!this.props.clientAdAccount.has_internal_problem)
            return "";
        return <span style={{fontWeight: "600"}}>
            {t('clients.account_error_since')} {this.props.clientAdAccount.last_access_check}<br/>
            <span title={this.props.clientAdAccount.error_found}>
                {t('clients.connection_lost_friendly')}
            </span><br/>
        </span>;
    }

    renderAccessStatus() {
        const { t } = this.props;
        const icon = this.adAccountIsOk() ? "check" : "exclamation-triangle";
        const extraClassOnError = this.adAccountIsOk() ? "" : "no-impressions-alert";
        const noAccessTextDetail = this.props.clientAdAccount.has_access ? "" : <span style={{fontWeight: "600"}}>{t('clients.no_access_since')} {this.props.clientAdAccount.no_access_since}<br/></span>;
        //const internalProblemTextDetail = this.props.clientAdAccount.has_internal_problem ? <span style={{fontWeight: "600"}}>Cuenta deshabilitada: {this.props.clientAdAccount.no_access_since}<br/></span> : "";
        const internalProblemTextDetail = this.getInternalProblemTextDetail();

        const channelInfo = CHANNEL_INFO_BY_CHANNEL[this.props.clientAdAccount.channel];
        const isPaidMedia = channelInfo && channelInfo.channelType === CHANNEL_TYPE_PAID_MEDIA;
        const showReconnect = !this.props.clientAdAccount.has_access && isPaidMedia;

        return (
            <div className="access-status-cell">
                <div className={"bu-cell-icon " + extraClassOnError}>
                    <FaIcon iconName={icon}/>
                    <div className="bu-tooltip">
                        <FaIcon iconName={icon}/>
                        <p className="tooltip-description">
                            {noAccessTextDetail}{internalProblemTextDetail}
                            {t('clients.last_check')} {this.props.clientAdAccount.last_access_check}
                        </p>
                    </div>
                </div>
                {showReconnect && (
                    <>
                        <span
                            className="reconnect-link"
                            onClick={this.handleReconnectToggle}
                            title={t('reconnect_modal.reconnect')}
                        >
                            <FaIcon iconName="sync-alt" /> {t('reconnect_modal.reconnect')}
                        </span>
                        <ReconnectAdAccountModal
                            isOpen={this.state.showReconnectModal}
                            onToggle={this.handleReconnectToggle}
                            adAccountData={{
                                ad_account_id: this.props.clientAdAccount.ad_account_id,
                                name: this.props.clientAdAccount.name,
                                channel: this.props.clientAdAccount.channel,
                            }}
                            onReconnected={() => window.location.reload()}
                        />
                    </>
                )}
            </div>
        );
    }

    adAccountIsOk() {
        return this.props.clientAdAccount.has_access && !this.props.clientAdAccount.has_internal_problem;
    }

    isMonitoringMode() {
        return this.props.mode === undefined || this.props.mode === VIEW_MODE_CLIENT_MONITORING;
    }

    isConnectionMode() {
        return this.props.mode === VIEW_MODE_CLIENT_ACCOUNTS;
    }

    isAgencyAccountsViewMode() {
        return this.props.mode === VIEW_MODE_AGENCY_ACCOUNTS;
    }

    getBudgetDetailColumnData() {
        if(!this.isMonitoringMode() && !this.isAgencyAccountsViewMode())
            return;

        return <td>
            <AdAccountBudgetWithDetails currency={this.props.clientAdAccount.currency_code}
                                        dailyBudget={this.props.clientAdAccount.daily_budget}
                                        channelHasBudgets={this.props.clientAdAccount.channel_has_campaigns_with_budgets}
                                        dailyBudgetUpdatedOn={this.props.clientAdAccount.last_campaigns_sync}
                                        campaignsLastUpdate={this.props.clientAdAccount.campaigns_last_update}
                                        hasAccess={this.props.clientAdAccount.has_access}
                                        hasInternalProblem={this.props.clientAdAccount.has_internal_problem}
                                        maxCampaignDailyBudget={this.props.clientAdAccount.max_campaign_daily_budget}
                                        adAccountId={this.props.clientAdAccount.ad_account_id}

            />
        </td>;
    }

    dailyLimitColumnData() {
        if(this.isConnectionMode())
            return;

        return (
            <td>
                {this.renderDailyLimitColumnText()}
            </td>
        );
    }

    getClientColumnData() {
        if (this.props.showClientColumn) {
            return (<td>
                {this.props.clientAdAccount.agency_client_name}
            </td>)
        } else {
            return null;
        }
    }

    render() {
        return (
            <React.Fragment>
                <tr key={this.props.clientAdAccount.id}>
                    <td style={{paddingLeft: '0.4em'}}>
                        {this.renderAccountColumnText()}
                    </td>
                    <td>
                        {this.props.clientAdAccount.currency_code}
                    </td>
                    {this.getClientColumnData()}
                    {this.getBudgetDetailColumnData()}
                    {this.dailyLimitColumnData()}
                    {this.monitoringColumnData()}
                    {this.selectedEventsColumnData()}
                    {this.integrationsColumnData()}
                    <td>
                        {this.renderAccessStatus()}
                    </td>
                    <td>
                        <span style={{marginLeft: "5px"}}>
                            <YesNoModal onYesAnswer={this.handleClientAdAccountRemove}
                                        title={this.props.t('clients.unlink_ad_account_title')}
                                        message={this.props.t('clients.unlink_ad_account_message')}
                                        question={this.props.t('clients.unlink_ad_account_question')}
                                        buttonClassName={""}
                                        buttonText={""}
                                        buttonTitle={this.props.t('clients.unlink_ad_account_button')}
                                        buttonIconName={"trash"}
                                        isSaving={this.state.isSaving}
                            />
                        </span>
                    </td>
                </tr>
                {this.state.showEditEventsModal && (
                    <EditEventsModal
                        isOpen={this.state.showEditEventsModal}
                        toggle={() => this.setState({showEditEventsModal: false})}
                        clientAdAccount={this.props.clientAdAccount}
                        onSaved={this.handleClientAdAccountEdited}
                    />
                )}
            </React.Fragment>
        );
    }

    hasDailyLimit(clientAdAccount) {
        return clientAdAccount.daily_limit_type !== null && clientAdAccount.daily_limit_currency !== null && clientAdAccount.daily_limit_value !== null;
    }

    includedInActiveBusinessUnitColumnData() {
        if(!this.isConnectionMode())
            return;

        return <td>{this.props.clientAdAccount.active_business_units}</td>;
    }

    monitoringColumnData() {
        if(!this.isConnectionMode())
            return;

        const { t, clientAdAccount } = this.props;
        const channelInfo = CHANNEL_INFO_BY_CHANNEL[clientAdAccount.channel];
        const hasDailyLimit = channelInfo.dailyLimitEnabled && this.hasDailyLimit(clientAdAccount);
        const busCount = clientAdAccount.active_business_units || 0;

        // Empty state: no daily limit and no BUs
        const noLimit = !channelInfo.dailyLimitEnabled || !hasDailyLimit;
        if (noLimit && busCount === 0) {
            return (
                <td>
                    <div className="monitoring-cell -empty">
                        <span className="monitoring-empty-icon">
                            <FaIcon iconName="ban"/>
                            <span className="monitoring-empty-tooltip">
                                {t('client_ad_account_stores_list.monitoring_empty_tooltip')}
                            </span>
                        </span>
                    </div>
                </td>
            );
        }

        const busText = busCount === 1
            ? t('client_ad_account_stores_list.monitoring_bus_one', { count: busCount })
            : t('client_ad_account_stores_list.monitoring_bus_other', { count: busCount });

        return (
            <td>
                <div className="monitoring-cell">
                    {channelInfo.dailyLimitEnabled && (
                        hasDailyLimit ? (
                            <span className="monitoring-tag -limit">
                                <FaIcon iconName="shield-alt"/>
                                {clientAdAccount.daily_limit_currency} {'$' + Number(clientAdAccount.daily_limit_value).toLocaleString('en-US')}
                            </span>
                        ) : (
                            <span className="monitoring-tag -no-limit">
                                {t('client_ad_account_stores_list.monitoring_no_limit')}
                            </span>
                        )
                    )}
                    <span className="monitoring-tag -bus">
                        <FaIcon iconName="layer-group"/>
                        {busText}
                    </span>
                </div>
            </td>
        );
    }

    lookerStudioColumnData() {
        if(!this.isConnectionMode() && !this.isAgencyAccountsViewMode())
            return;

        return <td><LookerCCStatus hasConnection={this.props.clientAdAccount.has_connection} looker_cc_status_data={this.props.clientAdAccount.looker_cc_status_data} /></td>;
    }

    dataNodeColumnData() {
        if(!this.isConnectionMode() && !this.isAgencyAccountsViewMode())
            return;

        return <td><DataNodeStatus hasConnection={this.props.clientAdAccount.has_connection} data_node_status_data={this.props.clientAdAccount.looker_cc_status_data} /></td>;
    }

    mcpColumnData() {
        if(!this.isConnectionMode() && !this.isAgencyAccountsViewMode())
            return;

        return <td><MCPStatus hasConnection={this.props.clientAdAccount.has_connection} mcp_status_data={this.props.clientAdAccount.looker_cc_status_data} /></td>;
    }

    selectedEventsColumnData() {
        if(!this.isConnectionMode())
            return;

        const { t, clientAdAccount } = this.props;
        const channelInfo = CHANNEL_INFO_BY_CHANNEL[clientAdAccount.channel];

        if (!channelInfo.hasActions) {
            return <td><span className="text-muted">-</span></td>;
        }

        const editBtn = (
            <button className="edit-events-btn" title={t('edit_events_modal.title')} onClick={() => this.setState({showEditEventsModal: true})}>
                <FaIcon iconName="pencil"/>
            </button>
        );

        if (channelInfo.hasPrimaryConversions && clientAdAccount.use_all_primary_conversions) {
            return (
                <td>
                    <div className="events-cell">
                        <span className="conversion-badge -all">{t('client_ad_account_stores_list.all_primary_conversions')}</span>
                        {editBtn}
                    </div>
                </td>
            );
        }

        if (clientAdAccount.selected_actions && clientAdAccount.selected_actions.length > 0) {
            return (
                <td>
                    <div className="events-cell">
                        <div className="events-badge-wrapper">
                            <span className="conversion-badge -count">{t('client_ad_account_stores_list.n_events', { count: clientAdAccount.selected_actions.length })}</span>
                            <div className="bu-tooltip">
                                <p className="tooltip-description">
                                    {clientAdAccount.selected_actions.map((action, i) => (
                                        <React.Fragment key={i}>
                                            {i > 0 && <br/>}
                                            {getTranslatedName(action) || stripActionPrefix(action)}
                                        </React.Fragment>
                                    ))}
                                </p>
                            </div>
                        </div>
                        {editBtn}
                    </div>
                </td>
            );
        }

        return (
            <td>
                <div className="events-cell">
                    <span className="conversion-badge -none">{t('client_ad_account_stores_list.not_configured')}</span>
                    {editBtn}
                </div>
            </td>
        );
    }

    _getIntegrationStatus(statusData, hasConnection) {
        if (!hasConnection || !statusData) return 'inactive';
        if (statusData.status === "PROCESSING") return 'processing';
        if (statusData.status === "COMPLETE" || (statusData.completed_percentage && statusData.completed_percentage >= 100)) return 'active';
        return 'inactive';
    }

    _getHelpArticleForIntegration(i18nPrefix) {
        const map = {
            'looker_cc': HELP_LOOKER_CC,
            'data_node': HELP_DATA_EXPLORER,
            'mcp_status': HELP_MCP_INTERNAL,
        };
        return map[i18nPrefix];
    }

    _renderIntegrationTooltip(status, statusData, hasConnection, i18nPrefix, descriptionKey) {
        const { t } = this.props;

        if (status === 'active') {
            const helpArticle = this._getHelpArticleForIntegration(i18nPrefix);
            return (
                <div className="bu-tooltip looker-cc-tooltip">
                    <p className="tooltip-description status-no-included">
                        {t(descriptionKey)}
                        {helpArticle && <><br/><br/><LinkToArticle article={helpArticle}/></>}
                    </p>
                </div>
            );
        }

        if (status === 'processing') {
            const percentage = statusData?.completed_percentage || 0;
            return (
                <div className="bu-tooltip looker-cc-tooltip">
                    <p className="tooltip-description">
                        {t(`${i18nPrefix}.processing_tooltip`, { percentage })}<br/><br/>
                        {t(`${i18nPrefix}.processing_connection_issue`)}<br/>
                        {t(`${i18nPrefix}.processing_contact`)}
                    </p>
                </div>
            );
        }

        // inactive
        const tooltipKey = !hasConnection ? 'not_included_or_not_connected' : 'not_included_tooltip';
        const helpArticle = this._getHelpArticleForIntegration(i18nPrefix);
        return (
            <div className="bu-tooltip looker-cc-tooltip">
                <p className="tooltip-description status-no-included">
                    {t(`${i18nPrefix}.${tooltipKey}`)}
                    {helpArticle && <><br/><br/><LinkToArticle article={helpArticle}/></>}
                </p>
            </div>
        );
    }

    integrationsColumnData() {
        if(!this.isConnectionMode() && !this.isAgencyAccountsViewMode())
            return;

        const { clientAdAccount } = this.props;
        const statusData = clientAdAccount.looker_cc_status_data;
        const hasConnection = clientAdAccount.has_connection;
        const status = this._getIntegrationStatus(statusData, hasConnection);

        const integrations = [
            { key: 'looker', icon: 'chart-bar', i18nPrefix: 'looker_cc', descriptionKey: 'looker_cc.description' },
            { key: 'data_explorer', icon: 'binoculars', i18nPrefix: 'data_node', descriptionKey: 'data_node.explorer_description' },
            { key: 'connect', icon: 'microchip', i18nPrefix: 'mcp_status', descriptionKey: 'mcp_status.description' },
        ];

        return (
            <td>
                <div className="integration-icons">
                    {integrations.map(item => (
                        <span key={item.key}
                              className={`integration-icon bu-cell-icon -${status}`}>
                            <FaIcon iconName={item.icon}/>
                            {this._renderIntegrationTooltip(status, statusData, hasConnection, item.i18nPrefix, item.descriptionKey)}
                        </span>
                    ))}
                </div>
            </td>
        );
    }

    isNewLimitLikelyExceeded() {
        const {
            daily_limit_currency,
            daily_limit_value,
            daily_limit_type,
            daily_limit_last_exceed_notification_currency,
            daily_limit_last_exceed_notification_value,
            daily_limit_last_exceed_notification_is_today,
            max_campaign_daily_budget,
            daily_budget
        } = this.props.clientAdAccount;

        // Si la notificación no fue hoy, no podemos determinar si está excedido
        if (!daily_limit_last_exceed_notification_is_today) {
            return false;
        }

        // Si la moneda cambió, no podemos comparar directamente, así que asumimos que podría estar excedido
        if (daily_limit_currency !== daily_limit_last_exceed_notification_currency) {
            return true;
        }

        const newLimit = Number(daily_limit_value);
        const previousExceededLimit = Number(daily_limit_last_exceed_notification_value);

        // Para límites de tipo "Campaña", comparar con el presupuesto máximo de campaña actual
        if (daily_limit_type === DAILY_LIMIT_TYPE_DAILY_CAMPAIGN_ONLY_BUDGET && max_campaign_daily_budget !== null && max_campaign_daily_budget !== undefined) {
            const maxCampaignBudget = Number(max_campaign_daily_budget);
            // Si el nuevo límite es menor que el presupuesto máximo de campaña, sigue excedido
            return newLimit < maxCampaignBudget;
        }

        // Para límites de tipo "Cuenta" (presupuesto y consumo), comparar con el presupuesto diario total
        if (daily_limit_type === DAILY_LIMIT_TYPE_DAILY_AD_ACCOUNT_COST_AND_BUDGET && daily_budget !== null && daily_budget !== undefined) {
            const totalDailyBudget = Number(daily_budget);
            // Si el nuevo límite es menor que el presupuesto diario total, podría estar excedido
            return newLimit < totalDailyBudget;
        }

        // Si no tenemos datos actuales para comparar, usar la lógica conservadora:
        // Si el nuevo límite es menor o igual al límite anterior que estaba excedido,
        // es muy probable que también esté excedido
        return newLimit <= previousExceededLimit;
    }

    renderDailyLimitExceedNotification() {
        const {
            daily_limit_currency,
            daily_limit_value,
            daily_limit_last_exceed_notification_at,
            daily_limit_last_exceed_notification_currency,
            daily_limit_last_exceed_notification_value,
            daily_limit_last_exceed_notification_is_today
        } = this.props.clientAdAccount;

        if (!daily_limit_last_exceed_notification_at) {
            return null;
        }

        const limitValuesChanged = daily_limit_currency !== daily_limit_last_exceed_notification_currency ||
                                   Number(daily_limit_value) !== Number(daily_limit_last_exceed_notification_value);

        const { t } = this.props;
        
        // Si la notificación fue hoy y los valores no cambiaron, mostrar notificación
        if (daily_limit_last_exceed_notification_is_today && !limitValuesChanged) {
            const tooltip_text = `${t('clients.limit_exceeded_today')} ${daily_limit_last_exceed_notification_at}`;
            return (
                <div className={"bu-cell-icon"} style={{color: "#dc3545", marginLeft: "10px", display: "flex", alignItems: "center"}}>
                    <FaIcon iconName="exclamation-triangle" />
                    <div className="bu-tooltip">
                        <FaIcon iconName="exclamation-triangle"/>
                        <p className="tooltip-description">{tooltip_text}</p>
                    </div>
                    <span style={{marginLeft: "5px", color: "#dc3545"}}>{t('clients.limit_exceeded')}</span>
                </div>
            );
        }
        
        // Si los valores cambiaron pero el nuevo límite probablemente también está excedido, mostrar notificación
        if (daily_limit_last_exceed_notification_is_today && limitValuesChanged && this.isNewLimitLikelyExceeded()) {
            const tooltip_text = `${t('clients.limit_exceeded_today')} ${daily_limit_last_exceed_notification_at}`;
            return (
                <div className={"bu-cell-icon"} style={{color: "#dc3545", marginLeft: "10px", display: "flex", alignItems: "center"}}>
                    <FaIcon iconName="exclamation-triangle" />
                    <div className="bu-tooltip">
                        <FaIcon iconName="exclamation-triangle"/>
                        <p className="tooltip-description">{tooltip_text}</p>
                    </div>
                    <span style={{marginLeft: "5px", color: "#dc3545"}}>{t('clients.limit_exceeded')}</span>
                </div>
            );
        }
        
        // Si la notificación fue en otro día o el nuevo límite probablemente no está excedido, mostrar info
        const formattedValue = Number(daily_limit_last_exceed_notification_value).toLocaleString('en-US');
        const value = `${daily_limit_last_exceed_notification_currency} $${formattedValue}`;
        const tooltip_text = `${t('clients.limit_exceeded_on')} ${daily_limit_last_exceed_notification_at} ${t('clients.limit_exceeded_with_value')} ${value}`;

        return (
            <div className={"bu-cell-icon"} style={{marginLeft: "10px"}}>
                <FaIcon iconName="info-circle" />
                <div className="bu-tooltip">
                    <FaIcon iconName="info-circle"/>
                    <p className="tooltip-description">{tooltip_text}</p>
                </div>
            </div>
        );
    }

    renderDailyLimitColumnText() {
        if(!CHANNEL_INFO_BY_CHANNEL[this.props.clientAdAccount.channel].dailyLimitEnabled)
            return;

        let content = null;
        let notification = null;

        const has_daily_limit = this.hasDailyLimit(this.props.clientAdAccount);

        if (this.isMonitoringMode() || this.isAgencyAccountsViewMode()) {
            notification = this.renderDailyLimitExceedNotification();

            if (!has_daily_limit) {
                content = <Alert className="alert-label alert-danger">{this.props.t('clients.no_daily_limit')}{this.renderEditDailyLimitButton()}</Alert>;
            } else {
                let a_type = this.props.clientAdAccount.daily_limit_type;
                let currency = this.props.clientAdAccount.daily_limit_currency;
                let value = this.props.clientAdAccount.daily_limit_value;

                const { i18n } = this.props;
                const formattedValue = Number(value).toLocaleString('en-US');
                const type_text = `[${getLocalizedShortText(DAILY_LIMIT_TYPE_DATA[a_type], i18n.language)}]   `;
                value = `$ ${formattedValue}`;
                content = <Alert className="alert-label alert-success" style={{
                    textAlign: "center",
                    padding: "3px 0 3px 0",
                    margin: "0 0 0 0",
                    width: "200px"
                }}>{type_text} {currency} {value}{this.renderEditDailyLimitButton()}</Alert>;
            }
        } else {
            if (!has_daily_limit) {
                content = <div className={"bu-cell-icon fa-icon status-not-included"}>
                    <FaIcon iconName="times-circle"/>
                </div>;
            } else {
                content = <div className={"bu-cell-icon fa-icon status-ok"}>
                    <FaIcon iconName="check-circle"/>
                </div>;
            }
        }

        return (<span style={{ display: 'flex', alignItems: 'center' }}>
                {content}
                {notification}
            </span>
        );
    }

    renderEditDailyLimitButton() {
        return <EditClientAdAccountModalButton
            onClientAdAccountEdited={this.handleClientAdAccountEdited}
            clientAdAccount={this.props.clientAdAccount}
            clientId={this.props.clientAdAccount.agency_client_id}
            clientName={this.props.clientAdAccount.agency_client_name}/>;
    }

    renderAccountColumnText() {
        return (
            <div style={{minWidth: "200px", paddingTop: "10px", paddingBottom: "10px"}}>
                <span style={{float: "left", paddingLeft: '0'}}>
                    <ChannelLogo useOld={false} width="20px" height={"20px"} channel={this.props.clientAdAccount.channel} marginLeft={"5px"}/>
                </span>
                <span style={{float: "left", paddingLeft: '0'}}>
                    {this.props.clientAdAccount.account_id}<br/>{this.props.clientAdAccount.name}
                </span>
            </div>
        )
    }
}

export const ClientAdAccountRow = withTranslation()(ClientAdAccountRowClass);
export default ClientAdAccountRow;
